import projection from '../generated/pwn503f1.json';
import { AcceptanceManifest } from '../types';
export const pwn503f1AcceptanceManifest = projection as AcceptanceManifest;
